import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4005BD44-56B4-4F6E-962D-EF83ED5C69EC
 * name flag-variant-plus
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-variant-plus.svg
 * tags
 */
export const FlagVariantPlusIcon = createSvgIcon(<><path d="M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" /></>, 'FlagVariantPlusIcon');
export default FlagVariantPlusIcon